import { connect } from 'react-redux';

import { selectors as userSelectors } from 'dux/user';
import { selectors as orgSelectors } from 'dux/org';
import { actionCreators as usersManagementActionCreators } from 'dux/usersManagement';
import UserActionsMenu from './UserActionsMenu';

const mapStateToProps = (state) => ({
  userRoles: userSelectors.getIdentityState(state).roles,
  orgORv4ID: orgSelectors.orgORv4IDSelector(state),
});

const mapDispatchToProps = {
  updateUsersState: usersManagementActionCreators.updateUsersState,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserActionsMenu);
